var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuthProvider, useLucidSdk } from '#context';
import { usePlugFilespaceClient } from '../../../hooks';
import { FilespaceEntryContentKeyFactory } from '../../../query-key-factories';
import { getDirContentsRefetchInterval, readAllDirEntries, readDirContents, } from '../../../services';
export const useFsEntryGetAllContents = ({ browserInstance, filespaceId, key, workspaceId, }) => {
    _react_refresh_temp_1();
    const queryClient = useQueryClient();
    const { lucidSdk } = useLucidSdk();
    const { currentUser } = useAuthProvider();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const queryKey = FilespaceEntryContentKeyFactory.exact(filespaceId, key?.id || '');
    const query = useQuery({
        queryKey,
        queryFn: async () => {
            if (!key) {
                return [];
            }
            return readDirContents({
                browserInstance,
                filespaceId,
                lucidSdk,
                queryClient,
                queryKey,
                read: () => plugFilespaceClient({
                    action: (fsClient) => readAllDirEntries(fsClient, key),
                    filespaceId,
                    workspaceId,
                }),
                workspaceId,
            });
        },
        enabled: Boolean(currentUser?.emailVerified && key && key.id.length),
        refetchInterval: (query) => getDirContentsRefetchInterval(query.state.data?.length),
        networkMode: 'always',
    });
    return { query };
};
_react_refresh_temp_1(useFsEntryGetAllContents, "eIRk+WB3gBoLz+PRsLfd4YBYCkY=", false, () => [useQueryClient, useLucidSdk, useAuthProvider, usePlugFilespaceClient, useQuery]);
